<template>
    <div>
        <button class="ds-btn" @click="isModalVisible = true">Pievienot</button>

        <b-modal v-model="isModalVisible" no-close-on-backdrop hide-footer body-class="p-2" header-class="bg-light align-items-center"
                 size="lg">
            <div slot="modal-title">
                <h3 class="h4 text-dark font-weight-light m-0">Jauna kategorija</h3>
            </div>
            <div slot="modal-header-close">
            </div>
            <TemplateCategoriesBaseForm v-if="isTemplate" @finished="handleCategoryCreation"/>
            <CategoriesBaseForm v-else @finished="handleCategoryCreation"/>
        </b-modal>
    </div>
</template>
<script>
    import {mapActions, mapGetters} from 'vuex';

    import CategoriesBaseForm from './CategoriesBaseForm';
    import TemplateCategoriesBaseForm from './TemplateCategoriesBaseForm';
    import * as categoryStoreTypes from '../../vuex/modules/category/category.store-types';
    import * as companyStoreTypes from '../../vuex/modules/company/company.store-types';

    export default {
        name: 'categories-add',
        components: {CategoriesBaseForm, TemplateCategoriesBaseForm},
        data: () => ({isModalVisible: false}),
        computed: {
            ...mapGetters('category', {
                /** @type {boolean|*} */
                isTemplate: categoryStoreTypes.GET_IS_TEMPLATE,
            }),
            ...mapGetters('company', {
                /** @type {Company|*} */
                currentCompany: companyStoreTypes.GET_CURRENT_COMPANY,
            }),
        },
        methods: {
            ...mapActions('category', {
                /** @type {function|*} */
                getCategories: categoryStoreTypes.ACTION_GET_CATEGORIES,
            }),
            handleCategoryCreation() {
                this.isModalVisible = false;

                //For template categories currentCompany._id will be empty
                this.getCategories({companyId: this.currentCompany._id});
            },
        },
    }
</script>